import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcel, getTransporters } from '@/api/transporters';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import Inr from '@/components/Inr/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { getAllCities } from '@/api/locations/cities';
import { isAdmin, isSuperAdmin } from '@/common';
import { BranchAgentService } from '@/services/branch-agent-service';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.cityList = [];
    this.cityListLoading = false;
    this.listLoading = true;
    this.branchListLoading = false;
    this.branchList = [];
    this.downloadLoading = false;
    this.assignedBranches = [] || null;
    this.showFilters = false;
    this.listQuery = {
      enabled: true,
      page: 1,
      limit: 10,
      sort: 'id,ASC',
      name: undefined,
      gstNumber: undefined,
      cityId: undefined,
      branchId: undefined,
      applyBranchIdFilter: true,
      filter: {
        name: '$contL',
        gstNumber: '$contL',
        cityId: '$eq',
        branchId: '$in',
        enabled: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  async activated() {
    // Assign branchId using BranchAgentService
    // this.listQuery.branchId = await BranchAgentService.assignBranchId();
    this.assignedBranches = await BranchAgentService.assignBranchId();
    // Check if branchId is null and throw an error
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    await this.getList();
    this.getCityList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await getTransporters(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getCityList(query = null) {
    try {
      if (query && query.length > 1) {
        this.cityListLoading = true;
        this.cityList = await getAllCities(getQuery({
          name: query,
          filter: {
            name: '$contL'
          }
        }));
      }
      this.cityListLoading = false;
    } catch (error) {
      this.cityListLoading = false;
    }
  }
  async handleClearBranch() {
    // Assign branchId using BranchAgentService
    this.listQuery.branchId = await BranchAgentService.assignBranchId();
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.listQuery.branchId);
  }
  async handleFilter() {
    var _AdminModule$branchId;
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      const blob = await downloadExcel(queryWithoutPagination);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'transporters.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'BrandList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;